import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  DetailsChartsDto,
  PtPermissions,
  TREATMENT_GAUGE_PALETTE_MAX_5,
  TREATMENT_GAUGE_PALETTE_MAX_9,
  TreatmentChart
} from '@pt/pt-models';
import { RiskEvaluationGroup } from 'it/primatoo/openapi/api/org/schemas/treatment/riskassessment/RiskEvaluationGroup';
import {
  GetTreatmentForDetailsResponse
} from 'it/primatoo/openapi/api/org/schemas/treatment/GetTreatmentForDetailsResponse';
import { StatsChartBuilder } from '../../utils/stats-chart-builder';
import { DpiaEvalRow } from 'it/primatoo/openapi/api/org/schemas/dpia/dpiaevaluation/DpiaEvalRow';
import { DpiaColumn } from 'it/primatoo/openapi/api/org/schemas/dpia/dpiaevaluation/DpiaColumn';

@Component({
  selector: 'pt-treatment-details-result',
  template: `
    <div class="mb-2 mt-4">

      <div class="d-flex align-items-start flex-row">

        <pt-details-chart
          class="w-50"
          [showReloadButton]='false'
          [title]='"LABELS.RISK_FACTOR" | translate'
          [gaugeColor]='treatmentGaugeColor'
          [charts]='treatmentRiskFactors'>
        </pt-details-chart>

        <!--      // CYBER SEC-->

        <pt-details-app-score
          *ngxPermissionsOnly='[PtPermissions.ACTIVE_MODULE_CYBERSEC]'
          class="w-50"
          [title]='"LABELS.SCORE_VULNERABILITY" | translate'
          [titleHelp]="'TOOLTIP.SCORE_VULNERABILITY' | translate"
          [value]="details?.cyberSec?.appScore">
        </pt-details-app-score>
      </div>

      <pt-risk-assessment-stats
        [mode]='"select"'
        [title]="'TITLE.RISK_SCENARIO_ASSESSMENT' | translate"
        [showReload]="false"
        [evaluation]='riskAssessmentEvaluation'
      ></pt-risk-assessment-stats>

      <!--      // CYBER SEC-->
      <div class="mt-4" *ngxPermissionsOnly='[PtPermissions.ACTIVE_MODULE_CYBERSEC]'>
        <div class="stat-detail-container">
          <div class="dt-title">
            {{ "LABELS.EVALUATION_PROBABILITY_THREATS" | translate }}
          </div>
          <ng-select class="pt-select--custom"
                     [clearable]="false"
                     [(ngModel)]="activeChartsTab"
                     (click)="$event.stopPropagation();">
            <ng-container *ngFor="let item of treatmentChart">
              <ng-option [value]="item">
                {{ item.label | translate }}
              </ng-option>
            </ng-container>
          </ng-select>

          <pt-details-chart
            [title]="null"
            [charts]="activeChartsTab?.charts"
            [gaugeColor]="treatmentStatsGaugeColor"
          ></pt-details-chart>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .stat-detail-container {
      width: calc(100% - 30px);
      /*max-width: 375px;*/
    }

    .dt-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      font-size: 15px;
      font-weight: bold;
    }
  `]
})
export class TreatmentDetailsResultComponent implements OnChanges {
  @Input() details: GetTreatmentForDetailsResponse;
  public activeChartsTab: TreatmentChart;
  public treatmentGaugeColor = TREATMENT_GAUGE_PALETTE_MAX_9;
  public treatmentRiskFactors: DetailsChartsDto[];
  public treatmentAppScore: DetailsChartsDto[];
  public riskAssessmentEvaluation: Array<RiskEvaluationGroup>;
  // il selettore check mantiene i result del precedente capitolo aperto
  // DPIA
  public columns: DpiaColumn[] = [];
  public rows: DpiaEvalRow[] = [];
  protected readonly treatmentStatsGaugeColor = TREATMENT_GAUGE_PALETTE_MAX_5;
  public treatmentChart: TreatmentChart[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    this.alignWidget();
  }

  private alignWidget() {

    this.treatmentChart = StatsChartBuilder.buildTreatmentStats(
      this.details.cyberSec?.appsAuditEvaluation,
      this.details.cyberSec?.impactMetricsLabels
    );
    this.treatmentAppScore = [{
      label: null,
      textValue: null,
      value: this.details?.cyberSec?.appScore,
      max: this.details?.cyberSec?.appScore
    } as DetailsChartsDto
    ]
    this.treatmentRiskFactors = [{
      label: null,
      textValue: null,
      value: this.details?.evaluation?.treatmentRiskFactors ?? 0,
      max: 5
    } as DetailsChartsDto];

    this.riskAssessmentEvaluation = this.details?.evaluation?.riskAssessment?.groups;
    if (this.details?.evaluation?.dpia) {
      this.rows = this.details?.evaluation?.dpia.rows || []
      this.columns = this.details?.evaluation?.dpia.columns || [];
    } else {
      this.rows = []
      this.columns = [];
    }

    this.activeChartsTab = this.treatmentChart?.length > 0 ? this.treatmentChart[0] : undefined

  }

  protected readonly PtPermissions = PtPermissions;
}
